/**
 * Created by zuozhuo on 2018/3/26.
 */

import utils from "../utils";

// 安卓
function setupAndroidBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    //do your work here
    callback(window.WebViewJavascriptBridge);
  } else {
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      function() {
        //do your work here
        callback(window.WebViewJavascriptBridge);
      },
      false
    );
  }
}

// iOS
function setupiOSBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  const WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

/*
setupiOSBridge(function(bridge) {
  /!* Initialize your app here *!/

  bridge.registerHandler("JS Echo", function(data, responseCallback) {
    console.log("JS Echo called with:", data);
    responseCallback(data);
  });
  bridge.callHandler("ObjC Echo", { key: "value" }, function responseCallback(
    responseData
  ) {
    console.log("JS received response:", responseData);
  });
});
*/

function onBridgeReady(callback) {
  if (!utils.isFoApp()) {
    return;
  }
  if (utils.isIOS()) {
    setupiOSBridge(callback);
  } else if (utils.isAndroid()) {
    setupAndroidBridge(callback);
  }
}

function iOSCallHandler(bridge, name, data, nativeCallback) {
  bridge.callHandler(name, data, function(responseData) {
    nativeCallback(utils.ensureJSON(responseData));
  });
}

function androidCallHandler(bridge, name, data, nativeCallback) {
  bridge.callHandler(name, data, function(responseData) {
    nativeCallback(utils.ensureJSON(responseData));
  });
}

function androidRegisterHandler(bridge, name, handler) {
  bridge.registerHandler(name, function(dataFromAndroid, callbackToAndroid) {
    handler(utils.ensureJSON(dataFromAndroid), callbackToAndroid);
  });
}

function iosRegisterHandler(bridge, name, handler) {
  bridge.registerHandler(name, function(dataFromIOS, callbackToIOS) {
    handler(utils.ensureJSON(dataFromIOS), callbackToIOS);
  });
}

function callHandler(name, data, nativeCallback) {
  console.log("AppBridge调用:");
  console.log({
    name,
    data
  });
  onBridgeReady(function(bridge) {
    if (utils.isIOS()) {
      iOSCallHandler(bridge, name, data, nativeCallback);
    }
    if (utils.isAndroid()) {
      androidCallHandler(bridge, name, data, nativeCallback);
    }
  });
}

function registerHandler(name, handler) {
  console.log("AppBridge handler注册:" + name);

  onBridgeReady(function(bridge) {
    if (utils.isIOS()) {
      iosRegisterHandler(bridge, name, handler);
    }
    if (utils.isAndroid()) {
      androidRegisterHandler(bridge, name, handler);
    }
  });
}

export default {
  callHandler,
  registerHandler
};



// WEBPACK FOOTER //
// ./src/utils/bridge/bridge.js